// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6a26f14b","431":"f5084930","667":"2c37b996","707":"761c634e","977":"135a5406"}[chunkId] + ".chunk.js";
};